<template>
	<TagGroupForm
		:tag-group="tagGroup"
		:is-saving="isSaving"
		:title="transUcfirst('tag_group.create')"
		@save="save"
		@close="close"
	/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TagGroupForm from '@videotools/js/one/components/TagGroups/TagGroupForm';
import TagGroup, {
	SECTION_CUSTOM_EVENT,
	SECTION_CUSTOM_PARTICIPANT,
	SECTION_SCOREBOARD,
	VISIBILITY_PRIVATE,
} from '@videotools/js/api/entities/TagGroup';

export default {
	name:       'CreateTagGroup',
	components: { TagGroupForm },
	data() {
		return {
			tagGroup: null,
			isSaving: false,
		};
	},
	computed: {
		...mapGetters({
			createdTagGroups:         'tagGroups/createdTagGroups',
			defaultSectionButtons:    'tagGroups/defaultSectionButtons',
			additionalSectionButtons: 'tagGroups/additionalSectionButtons',
			availableSections:        'tagGroups/availableSections',
		}),
		generatedName() {
			const pad = (number, size) => {
				let num = number.toString();
				while (num.length < size) num = '0' + num;
				return num;
			};
			const currentCount = this.createdTagGroups.length;
			return `${this.transChoiceUcFirst('tag_group.tag_group', 1)} ${pad(currentCount + 1, 2)}`;
		},
	},
	created() {
		this.tagGroup = new TagGroup({
			name:       this.generatedName,
			visibility: VISIBILITY_PRIVATE,
			sections:   this.availableSections.filter(section => ![SECTION_SCOREBOARD, SECTION_CUSTOM_EVENT, SECTION_CUSTOM_PARTICIPANT].includes(section)),
			tagButtons: [...this.defaultSectionButtons, ...this.additionalSectionButtons],
		});
	},
	methods: {
		...mapActions({
			create:  'tagGroups/create',
			select:  'tagGroups/setSelected',
			getById: 'tagGroups/getById',
		}),
		async save(data) {
			this.isSaving = true;
			try {
				const { customButtons, ...tagGroupData } = data;
				const { id } = await this.create({ tagGroupData, customButtons: customButtons.added });
				const createdTagGroup = await this.getById(id);
				if (createdTagGroup) {
					await this.select(createdTagGroup);
				}
				this.close();
			} finally {
				this.isSaving = false;
			}
		},
		close() {
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
